import React, { Component, Fragment } from 'react';
import moment from 'moment';

class GoogleMap extends Component {
    constructor(props) {
        super(props);

        let icons = [
            '/img/marker-icons/blue-pin.png',
            '/img/marker-icons/dark-green-pin.png',
            '/img/marker-icons/dark-purple-pin.png',
            '/img/marker-icons/dark-red-pin.png',
            '/img/marker-icons/grey-pin.png',
            '/img/marker-icons/light-blue-pin.png',
            '/img/marker-icons/light-green-pin.png',
            '/img/marker-icons/orange-pin.png',
            '/img/marker-icons/purple-pin.png',
            '/img/marker-icons/yellow-pin.png',
            '/img/marker-icons/brown-pin.png',
            '/img/marker-icons/pink-pin.png',
        ];

        this.state = {
            markers: [],
            icons: icons,
            tipOffIcon: '/img/marker-icons/tip-off.png',
            wasteContainerIcon: '/img/marker-icons/waste-container.png',
            polylines: [],
        };
    }

    googleMapRef = React.createRef();

    componentDidMount() {
        let googleMapScript;
        //Check if Google Maps script is created, so it will not be loaded twice
        if (!document.getElementById('members-map')) {
            googleMapScript = document.createElement('script');
            googleMapScript.setAttribute('id', 'members-map');
            googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${this.props.mapsApiKey}&libraries=places`;
            window.document.body.appendChild(googleMapScript);
        } else {
            googleMapScript = document.getElementById('members-map');
        }
        googleMapScript.addEventListener('load', () => {
            this.googleMap = this.createGoogleMap();

            this.changeMarkers();
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedDate !== this.props.selectedDate || this.props.recreatePins) {
            this.changeMarkers();
        }
    }

    createGoogleMap = () =>
        new window.google.maps.Map(this.googleMapRef.current, {
            zoom: 8,
            center: {
                lat: 51.504331316,
                lng: -0.123166174,
            },
        });

    createMarker = (
        lat,
        lng,
        marker,
        created_at,
        address_line_1,
        address_line_2,
        postcode,
        id,
        media,
        job_name,
        customer_name,
        initials
    ) => {
        let icon = marker;
        const mediaImages = media
            .slice(0, 4)
            .map((mediaItem) => {
                return `<img
                            src="${mediaItem.url}"
                            style="width: 100px; height: 100px; object-fit: cover; margin: 5px;" 
                            alt="Job Media" 
                        />`;
            })
            .join('');

        let info = `<div>Creation Date: ${created_at}</div>
                    <div>Address: ${address_line_1}<br />
                    ${address_line_2}<br />
                    ${postcode}
                    </div>
                    <div>Job Type: ${job_name}</div>
                    <div>Customer Name: ${customer_name}</div>
                    <div>Images: ${mediaImages || 'No images'}</div>
                    `;
        let infoWindow = new google.maps.InfoWindow({
            content: info,
        });

        marker = new window.google.maps.Marker({
            position: new google.maps.LatLng(Number(lat), Number(lng)),
            map: this.googleMap,
            icon: {
                url: icon,
            },
            title: name,
            label: {
                text: initials && initials,
                color: 'white',
                fontWeight: 'bold',
            },
        });

        marker.addListener('click', function () {
            infoWindow.open(this.googleMap, marker);
        });

        return marker;
    };

    createTipOffMarker = (lat, lng, name, id, address, postcode) => {
        const marker = new window.google.maps.Marker({
            position: new google.maps.LatLng(Number(lat), Number(lng)),
            map: this.googleMap,
            icon: {
                url: this.state.tipOffIcon,
            },
            title: name,
        });

        let info = `<div>Id: ${id}</div>
                    <div>Name: ${name}</div>
                    <div>Address: ${address}</div>
                    <div>Postcode: ${postcode}</div>`;
        let infoWindow = new google.maps.InfoWindow({
            content: info,
        });

        marker.addListener('click', function () {
            infoWindow.open(this.googleMap, marker);
        });

        return marker;
    };

    createWasteContainerMarker = (lat, lng, customerName, address, postcode) => {
        const marker = new window.google.maps.Marker({
            position: new google.maps.LatLng(Number(lat), Number(lng)),
            map: this.googleMap,
            icon: {
                url: this.state.wasteContainerIcon,
            },
            title: customerName,
        });

        const info = `<div>Customer: ${customerName}</div>
                    <div>Address: ${address}</div>
                    <div>Postcode: ${postcode}</div>`;

        let infoWindow = new google.maps.InfoWindow({
            content: info,
        });

        marker.addListener('click', function () {
            infoWindow.open(this.googleMap, marker);
        });

        return marker;
    };

    removeMarkers = () => {
        let markers = [...this.state.markers];
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        this.setState({
            markers: markers,
        });
    };

    getInitials = (member) => {
        const nameArray = member.split(' ');
        const firstName = nameArray[0].charAt(0).toUpperCase();
        const lastName = nameArray[nameArray.length - 1].charAt(0).toUpperCase();
        return firstName + lastName;
    };

    changeMarkers = () => {
        this.props.stopPinRecreation();
        for (let i = 0; i < this.state.polylines.length; i++) {
            this.state.polylines[i].setMap(null);
        }
        this.removeMarkers();

        let selectedDate = moment(this.props.selectedDate).format('YYYY-MM-DD');
        let markers = [];
        let bounds = new google.maps.LatLngBounds();
        let polylines = [];

        this.props.members.forEach((member, index) => {
            let jobs = [];
            if (typeof member['mapped_jobs'][selectedDate] !== 'undefined') {
                let polyline = [];
                jobs = member['mapped_jobs'][selectedDate].filter((job) => {
                    return job.execution_date === selectedDate;
                });
                jobs.forEach((job) => {
                    const initials = this.getInitials(member.name);

                    let marker = this.createMarker(
                        job.lat,
                        job.lng,
                        this.state.icons[index],
                        new Date(job.created_at).toLocaleDateString('en-GB'),
                        job.address_line_1,
                        job.address_line_2,
                        job.postcode || 'none',
                        job.id,
                        job.job_media,
                        job.job_type.name,
                        job.customer.name,
                        initials
                    );
                    markers.push(marker);
                    polyline.push(marker.position);
                    bounds.extend(marker.getPosition());
                });
                if (polyline.length > 0) {
                    polylines.push(
                        new google.maps.Polyline({
                            path: polyline,
                            strokeColor: '#FF0000',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                        })
                    );
                }
                this.googleMap.fitBounds(bounds);
            }

            if (polylines.length > 0) {
                polylines[polylines.length - 1].setMap(this.googleMap);
                this.setState({
                    polylines: polylines,
                });
            }
        });
        let unassignedJobsWithDate = this.props.unassignedJobs.filter((job) => {
            return job.execution_date;
        });
        let unassignedJobs = this.props.unassignedJobs.filter((job) => {
            return !job.execution_date;
        });
        unassignedJobs.forEach((unassignedJob) => {
            let marker = this.createMarker(
                unassignedJob.lat,
                unassignedJob.lng,
                '/img/marker-icons/red-pin.png',
                new Date(job.created_at).toLocaleDateString('en-GB'),
                job.address_line_1,
                job.address_line_2,
                job.postcode,
                job.id,
                job.job_media,
                job.job_type.name,
                job.customer.name
            );
            markers.push(marker);
            bounds.extend(marker.getPosition());
        });

        unassignedJobsWithDate.forEach((job) => {
            if (job.execution_date === selectedDate) {
                let marker = this.createMarker(
                    job.lat,
                    job.lng,
                    '/img/marker-icons/red-pin.png',
                    new Date(job.created_at).toLocaleDateString('en-GB'),
                    job.address_line_1,
                    job.address_line_2,
                    job.postcode,
                    job.id,
                    job.job_media,
                    job.job_type.name,
                    job.customer.name
                );
                markers.push(marker);
                bounds.extend(marker.getPosition());
            }
        });

        if (this.props.showTipOffs) {
            this.props.tipOffs.map((tipOff) => {
                let marker = this.createTipOffMarker(
                    tipOff.lat,
                    tipOff.lng,
                    tipOff.name,
                    tipOff.id,
                    tipOff.address_line_1,
                    tipOff.postcode
                );
                markers.push(marker);
                bounds.extend(marker.getPosition());
            });
        }

        if (this.props.showWasteCointainers) {
            this.props.wasteContainers.map((wasteContainer) => {
                let marker = this.createWasteContainerMarker(
                    wasteContainer.lat,
                    wasteContainer.lng,
                    wasteContainer.customer.name,
                    wasteContainer.address,
                    wasteContainer.postcode
                );
                markers.push(marker);
                bounds.extend(marker.getPosition());
            });
        }

        this.googleMap.fitBounds(bounds);

        this.setState({
            markers: markers,
        });
    };

    render() {
        return (
            <Fragment>
                <div className="col-md-12 mt-4">
                    <div id="google-map" ref={this.googleMapRef} style={{ width: '100%', height: '300px' }} />
                </div>
            </Fragment>
        );
    }
}

export default GoogleMap;
